import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/homepage'
import operation from '@/views/services/operation'
import dataCenter from '@/views/services/dataCenter'
import integration from '@/views/services/integration'
import itsourcing from '@/views/services/itsourcing'

// import outSolution from '@/views/solution/outSolution'
import vpnSolution from '@/views/solution/vpnSolution'
// import firmSolution from '@/views/solution/firmSolution'
// import mmSolution from '@/views/solution/mmSolution'
// import chainSolution from '@/views/solution/chainSolution'
// import serveSolution from '@/views/solution/serveSolution'
// import itSolution from '@/views/solution/itSolution'

import sdwan from '@/views/case/sdwan'
// import caseIdc from '@/views/case/idc'
// import caseDline from '@/views/case/dline'

import about from '@/views/about'

Vue.use(Router)

var router = new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/operation',
      name: 'operation',
      component: operation
    },
    {
      path: '/dataCenter',
      name: 'dataCenter',
      component: dataCenter
    },
    {
      path: '/integration',
      name: 'integration',
      component: integration
    },
    {
      path: '/sdwan',
      name: 'sdwan',
      component: sdwan
    },
    {
      path: '/itsourcing',
      name: 'itsourcing',
      component: itsourcing
    },
    {
      path: '/vpnSolution',
      name: 'vpnSolution',
      component: vpnSolution
    },
    {
      path: '/about',
      name: 'about',
      component: about
    }
  ]
})

router.beforeEach((to, from, next) => {
    next()
})

export default  router


// WEBPACK FOOTER //
// ./src/router/index.js